import type { ReactNode } from "react";

import AppNotification from "layouts/common-components/AppNotification";

import { ActiveTransactionProvider } from "./ActiveTransactionContext";
import { AuthProvider } from "./AuthContext";
import { BadgesProvider } from "./BadgesContext";
import { DictionariesProvider } from "./DictionariesContext";
import { NotifyProvider } from "./NotifyContext";
import { ReloadProvider } from "./ReloadContext";

// Order matters only in one place: Badges and Dictionaries read the auth state, so
// they sit inside AuthProvider. Everything else is independent.
function AppProvider({ children }: { children: ReactNode }) {
  return (
    <NotifyProvider>
      <AuthProvider>
        <BadgesProvider>
          <DictionariesProvider>
            <ReloadProvider>
              <ActiveTransactionProvider>
                {children}
                <AppNotification />
              </ActiveTransactionProvider>
            </ReloadProvider>
          </DictionariesProvider>
        </BadgesProvider>
      </AuthProvider>
    </NotifyProvider>
  );
}

export default AppProvider;
